var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 3.33329C1.66663 2.89127 1.84222 2.46734 2.15478 2.15478C2.46734 1.84222 2.89127 1.66663 3.33329 1.66663H11.6666C12.1087 1.66663 12.5326 1.84222 12.8451 2.15478C13.1577 2.46734 13.3333 2.89127 13.3333 3.33329V6.66663H16.6666C17.1087 6.66663 17.5326 6.84222 17.8451 7.15478C18.1577 7.46734 18.3333 7.89127 18.3333 8.33329V16.6666C18.3333 17.1087 18.1577 17.5326 17.8451 17.8451C17.5326 18.1577 17.1087 18.3333 16.6666 18.3333H8.33329C7.89127 18.3333 7.46734 18.1577 7.15478 17.8451C6.84222 17.5326 6.66663 17.1087 6.66663 16.6666V13.3333H3.33329C2.89127 13.3333 2.46734 13.1577 2.15478 12.8451C1.84222 12.5326 1.66663 12.1087 1.66663 11.6666V3.33329ZM8.33329 13.3333V16.6666H16.6666V8.33329H13.3333V11.6666C13.3333 12.1087 13.1577 12.5326 12.8451 12.8451C12.5326 13.1577 12.1087 13.3333 11.6666 13.3333H8.33329ZM11.6666 11.6666V3.33329H3.33329V11.6666H11.6666Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiCopy);
export default __webpack_public_path__ + "static/media/mi_copy.c3665d914754212ee69026162c00a731.svg";
export { ForwardRef as ReactComponent };